/* eslint-disable no-unused-vars */
export enum searchRadiusEnum {
  FIRST_RADIUS = 25,
  SECOND_RADIUS = 50,
  THIRD_RADIUS = 100,
  FOURTH_RADIUS = 200,
  DEFAULT_RADIUS = SECOND_RADIUS,
}
